<script>
export default {
	name: 'page-home'
}
</script>

<template>
	<page :class="classes">
		<h1>Hello world!</h1>
	</page>
</template>

<style lang="scss">
.c-page-home {
	text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/PageHome.vue